import config from '../config'
import { clearToken, getToken } from '../auth/session'

let onUnauthorized = null

export const DEFAULT_TIMEOUT_MS = 15000

/** Para procesos que el backend resuelve en la misma petición (lectura de Excel o carátulas). */
export const LONG_TIMEOUT_MS = 10 * 60 * 1000

export const setUnauthorizedHandler = (handler) => {
    onUnauthorized = handler
}

class APIInvoke {
    getAPIHeader() {
        const token = getToken()
        const headers = {
            'Content-Type': 'application/json',
            'cache-control': 'no-cache',
        }
        if (token) headers.Authorization = `Bearer ${token}`
        return headers
    }

    /** @param {string} url @param {{ timeoutMs?: number }} [options] */
    invokeGET(url, options = {}) {
        return this.invoke(url, { method: 'GET', headers: this.getAPIHeader() }, options)
    }

    /** @param {string} url @param {unknown} body @param {{ timeoutMs?: number }} [options] */
    invokePUT(url, body, options = {}) {
        return this.invoke(url, {
            method: 'PUT',
            headers: this.getAPIHeader(),
            body: JSON.stringify(body),
        }, options)
    }

    /** @param {string} url @param {unknown} [body] @param {{ timeoutMs?: number }} [options] */
    invokePOST(url, body, options = {}) {
        return this.invoke(url, {
            method: 'POST',
            headers: this.getAPIHeader(),
            body: body === undefined ? undefined : JSON.stringify(body),
        }, options)
    }

    /** @param {string} url @param {{ timeoutMs?: number }} [options] */
    invokeDELETE(url, options = {}) {
        return this.invoke(url, { method: 'DELETE', headers: this.getAPIHeader() }, options)
    }

    async resolveStoredFileUrl(storedUrl) {
        if (!storedUrl || !storedUrl.includes('digitaloceanspaces.com')) return storedUrl
        const response = await (await this.invokePOST('/storage/signed-url', { url: storedUrl })).json()
        if (!response.ok) throw new Error(response.message || 'No se pudo abrir el archivo.')
        return response.body.url
    }

    async uploadStorage(body) {
        const token = getToken()
        const headers = { 'cache-control': 'no-cache' }
        if (token) headers.Authorization = `Bearer ${token}`
        const response = await fetch(`${config.api.baseUrl}/storage/upload`, { method: 'POST', headers, body })
        if (response.status === 401) {
            clearToken()
            onUnauthorized?.()
        }
        return response
    }

    async invoke(url, params, { timeoutMs = DEFAULT_TIMEOUT_MS } = {}) {
        const finalURL = url.toLowerCase().startsWith('http') ? url : `${config.api.baseUrl}${url}`
        const controller = new AbortController()
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs)
        try {
            const response = await fetch(finalURL, { ...params, signal: controller.signal })
            if (response.status === 401 && !url.includes('/usuarios/login')) {
                clearToken()
                onUnauthorized?.()
            }
            return response
        } catch (error) {
            if (error.name === 'AbortError') {
                throw new Error('El servidor tardó demasiado en responder. Inténtalo de nuevo.')
            }
            throw new Error('No pudimos conectar con el servidor. Inténtalo de nuevo.')
        } finally {
            window.clearTimeout(timeout)
        }
    }
}

const apiInvoke = new APIInvoke()

export default apiInvoke
